/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateV2GoalRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {CreateV2GoalResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const createV2Goal = (request: CreateV2GoalRequest, options?: CashRequestOptions) => post<CreateV2GoalRequest, CreateV2GoalResponse>("/2.0/cash/create-v2-goal", request, {...options, rejectOnError: true })